import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=6516bece&"
import script from "./SearchHistory.vue?vue&type=script&lang=js&"
export * from "./SearchHistory.vue?vue&type=script&lang=js&"
import style0 from "./SearchHistory.vue?vue&type=style&index=0&id=6516bece&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports